import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {ErrorService} from '@app/services';
import {Video} from '../../video';

@Component({
  selector: 'hpf-video-create',
  templateUrl: './video-create.component.html'
})
export class VideoCreateComponent implements OnInit {
  /** The video */
  video = new Video();

  /** Constructor */
  constructor(private router: Router,
              private errorService: ErrorService) {
  }
  /** Init */
  ngOnInit() {
  }
  /** Called when the video is created */
  onCreate(video: Video): void {
    this.router.navigateByUrl(`/video/${video.getId()}`)
      .catch((error) => this.errorService.handle(error));
  }

}
